export function pinchZoom(element: HTMLElement) {
	let initialDistance = 0;
	let initialScale = 1;
	let currentScale = 1;
	let currentX = 0;
	let currentY = 0;
	let startX = 0;
	let startY = 0;
	let isDragging = false;
	let isActive = false;

	function getDistance(touches: TouchList): number {
		const dx = touches[0].clientX - touches[1].clientX;
		const dy = touches[0].clientY - touches[1].clientY;
		return Math.sqrt(dx * dx + dy * dy);
	}

	function applyTransform() {
		element.style.transform = `translate(${currentX}px, ${currentY}px) scale(${currentScale})`;
	}

	function handleTouchStart(e: TouchEvent) {
		if (e.touches.length === 2) {
			// Pinch zoom
			e.preventDefault();
			initialDistance = getDistance(e.touches);
			initialScale = currentScale;
			isActive = true;
		}
		if (e.touches.length === 1 && currentScale > 1) {
			// Pan only when already zoomed
			e.preventDefault();
			isDragging = true;
			startX = e.touches[0].clientX - currentX;
			startY = e.touches[0].clientY - currentY;
		}
		// Single finger on non-zoomed image: do nothing (allow default scroll behavior)
	}

	function handleTouchMove(e: TouchEvent) {
		if (e.touches.length === 2 && initialDistance > 0) {
			e.preventDefault();
			const currentDistance = getDistance(e.touches);
			const ratio = currentDistance / initialDistance;
			// Use logarithmic scaling for more natural feel
			const newScale = Math.log(ratio) + 1;
			currentScale = Math.max(1, Math.min(newScale * initialScale, 3)); // Limit between 1x and 2x
			applyTransform();
		}
		if (e.touches.length === 1 && isDragging) {
			e.preventDefault();
			currentX = e.touches[0].clientX - startX;
			currentY = e.touches[0].clientY - startY;
			applyTransform();
		}
	}

	function handleTouchEnd(e: TouchEvent) {
		if (e.touches.length < 2) {
			initialDistance = 0;
		}
		if (e.touches.length === 0) {
			isDragging = false;
			// Reset if zoomed out to 1x or less
			if (currentScale <= 1) {
				currentScale = 1;
				currentX = 0;
				currentY = 0;
				element.style.transition = 'transform 0.3s ease';
				applyTransform();
				setTimeout(() => {
					element.style.transition = '';
					isActive = false;
				}, 300);
			}
		}
	}

	function handlePointerEvents(pe: PointerEvent) {
		if (isDragging || currentScale > 1 || isActive) {
			pe.stopPropagation();
		}
	}

	// Add event listeners
	element.addEventListener('touchstart', handleTouchStart, { passive: false });
	element.addEventListener('touchmove', handleTouchMove, { passive: false });
	element.addEventListener('touchend', handleTouchEnd, { passive: false });

	element.addEventListener('pointerdown', handlePointerEvents, { passive: false });
	element.addEventListener('pointerup', handlePointerEvents, { passive: false });
	element.addEventListener('pointermove', handlePointerEvents, { passive: false });

	// Allow pan gestures but prevent default browser zoom
	element.style.touchAction = 'pan-x pan-y';
	element.style.userSelect = 'none';

	// Cleanup function
	return () => {
		element.removeEventListener('touchstart', handleTouchStart);
		element.removeEventListener('touchmove', handleTouchMove);
		element.removeEventListener('touchend', handleTouchEnd);

		element.removeEventListener('pointerdown', handlePointerEvents);
		element.removeEventListener('pointerup', handlePointerEvents);
		element.removeEventListener('pointermove', handlePointerEvents);

		element.style.touchAction = '';
		element.style.userSelect = '';
		element.style.transform = '';
	};
}
